import type { ResourceEndpoints } from '../core'

export const projectMappingsEndpoints = {
  collection: '/api/v1/project-mappings',
  item: (id: string) => `/api/v1/project-mappings/${encodeURIComponent(id)}`,
} satisfies ResourceEndpoints
